/// <reference path="./storage.js" />

(function(){
  (function addAnimCSS(){
    if (document.querySelector('style[data-st-token-anim]')) return;
    const css = `
      @keyframes stPulse {
        0%   { box-shadow:0 0 0 0 rgba(79,247,186,.55); }
        100% { box-shadow:0 0 0 16px rgba(79,247,186,0); }
      }
      .st-token-pill.st-anim {
        animation: stPulse .6s ease-out;
        transition: transform .2s ease;
        transform: scale(1.08);
      }
    `;
    const el = document.createElement('style');
    el.setAttribute('data-st-token-anim','true');
    el.textContent = css;
    document.head.appendChild(el);
  })();

  const $right = document.getElementById('st-header-right');
  const $mobileAuth = document.getElementById('st-mobile-auth');






  
  if ($right){
    const DASHBOARD_URL = $right.dataset.dashboardUrl || '/pages/account';
    const LOGIN_URL = '/account/login';
    const REGISTER_URL = '/account/register';

    function renderLoggedOut(){
      $right.innerHTML = `
        <button class="st-burger" id="st-burger-btn" aria-label="Menu" aria-controls="st-mobile-drawer" aria-expanded="false">☰</button>
        <a href="${LOGIN_URL}" class="st-link st-link--green"><span>Sign in</span></a>
        <a href="${REGISTER_URL}" class="st-link st-link--green"><span>Create Account</span></a>
      `;
      if ($mobileAuth){
        $mobileAuth.innerHTML = `
          <a class="auth-row auth-row--link" href="${LOGIN_URL}">Sign in</a>
          <a class="auth-row auth-row--link" href="${REGISTER_URL}">Create Account</a>
        `;
      }
    }

    function renderLoggedInWith(tokens){
      const n = Number.isFinite(tokens) ? tokens : 0;

      $right.innerHTML = `
        <button class="st-burger" id="st-burger-btn" aria-label="Menu" aria-controls="st-mobile-drawer" aria-expanded="false">☰</button>
        <a class="st-usericon" href="${DASHBOARD_URL}">
          <img src="https://cdn.shopify.com/s/files/1/0684/2482/7180/files/AVATARWHITE_ICON_09764a77-e90b-4cb6-a8d7-65d135312b29.png?v=1757958989" width="28" height="28" alt="">
        </a>
        <span class="st-token-pill" id="st-token-pill">${n}</span>
        <a href="#" id="st-signout" class="st-link st-link--white"><span>Sign out</span></a>
      `;

      if ($mobileAuth){
        $mobileAuth.innerHTML = `
          <a class="auth-row" href="${DASHBOARD_URL}">
            <img src="https://cdn.shopify.com/s/files/1/0684/2482/7180/files/AVATARWHITE_ICON_09764a77-e90b-4cb6-a8d7-65d135312b29.png?v=1757958989" width="24" height="24" style="filter:brightness(0) invert(1);" alt="">
            <span>Account</span>
          </a>
          <div class="auth-row auth-row--tokens">
            <span>Tasks:</span>
            <span class="st-token-pill" id="st-token-pill-mobile">${n}</span>
          </div>
          <a href="#" id="st-signout-mobile" class="auth-row auth-row--link">
            <span>Sign out</span>
          </a>
        `;
      }
    }

    function animatePillTo(value){
      const pill = document.getElementById('st-token-pill');
      const mobile = document.getElementById('st-token-pill-mobile');

      const to = Number(value);
      if (!Number.isFinite(to)) return;

      if (mobile) mobile.textContent = String(to);
      if (!pill) return;

      const from = Number(pill.textContent.replace(/[^\d.-]/g,'')) || 0;

      pill.classList.add('st-anim');
      setTimeout(()=> pill.classList.remove('st-anim'), 450);

      if (from === to){
        pill.textContent = String(to);
        return;
      }

      const dur = 500;
      const start = performance.now();

      function tick(now){
        const t = Math.min(1, (now - start) / dur);
        const eased = t < 0.5 ? 2*t*t : 1 - Math.pow(-2*t+2,2)/2;
        pill.textContent = String(Math.round(from + (to - from) * eased));
        if (t < 1) requestAnimationFrame(tick);
      }

      requestAnimationFrame(tick);
    }

    function setTokensAndBroadcast(newValue){
      const u = getUser() || {};
      u.tokens = Number(newValue) || 0;
      setUser(u);
      animatePillTo(u.tokens);
      window.dispatchEvent(new CustomEvent('st:tokens-updated', { detail:{ current: u.tokens }}));
    }

    function addTokens(delta){
      const d = Number(delta);
      if (!Number.isFinite(d)) return;
      const u = getUser() || {};
      const current = Number(u.tokens) || 0;
      const next = current + d;
      setTokensAndBroadcast(next);
    }
    window.ST_addTokens = addTokens;

    function bindSignoutHandlers(){
      const so = document.getElementById('st-signout');
      const som = document.getElementById('st-signout-mobile');

      function doSignout(ev){
        ev.preventDefault();
        try{
          removeFromLocalStorageForEnv('token');
          removeFromLocalStorageForEnv('user');
        }finally{
          window.location.href = '/';
        }
      }

      if (so) so.addEventListener('click', doSignout);
      if (som) som.addEventListener('click', doSignout);
    }

    const drawer = document.getElementById('st-mobile-drawer');

    function openDrawer(){
      if (!drawer) return;
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden','false');
      document.body.style.overflow = 'hidden';

      const b = document.getElementById('st-burger-btn');
      if (b){
        b.setAttribute('aria-expanded','true');
        b.classList.add('is-hidden');
      }
    }

    function closeDrawer(){
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden','true');
      document.body.style.overflow = '';

      const b = document.getElementById('st-burger-btn');
      if (b){
        b.setAttribute('aria-expanded','false');
        b.classList.remove('is-hidden');
      }
    }

    function bindBurgerHandlers(){
      const burger = document.getElementById('st-burger-btn');
      const closeBtn = document.getElementById('st-mobile-close');

      if (burger) burger.onclick = openDrawer;
      if (closeBtn) closeBtn.onclick = closeDrawer;

      if (drawer){
        drawer.querySelectorAll('a').forEach(a=>{
          a.addEventListener('click', closeDrawer);
        });
      }
    }

    function refreshFromStorage(){
      const user = getUser();
      let token;
      try{
        token = getToken();
      }catch(_){
        token = null;
      }

      if (token || (user && typeof user.tokens === 'number')){
        renderLoggedInWith(Number(user && user.tokens != null ? user.tokens : 0));
      } else {
        renderLoggedOut();
      }

      bindBurgerHandlers();
      bindSignoutHandlers();
    }

    refreshFromStorage();

    window.addEventListener('st:tokens-updated', (ev)=>{
      const d = ev && ev.detail ? ev.detail : {};
      const next = Number(d.current);

      if (!Number.isFinite(next)) return;

      const u = getUser() || {};
      u.tokens = next;
      setUser(u);

      if (!document.getElementById('st-token-pill')){
        refreshFromStorage();
      }

      animatePillTo(next);
    });

    window.addEventListener('storage', (e)=>{
      if (e.key === 'user' || e.key === 'token') refreshFromStorage();
    });
  }
})();

document.addEventListener('scroll', function(){
  const header = document.querySelector('.st-header');
  if (!header) return;
  if (window.scrollY > 20) header.classList.add('scrolled');
  else header.classList.remove('scrolled');
});
